import { State } from 'app/redux';

export const getOrderPriorities = (state: State) =>
  state.orderPriority.orderPriorities;
